import { Box } from '@zillow/constellation-10';

import { LandlordBlockCard } from '@renter-hub/modules/LandlordBlockCard/LandlordBlockCard.component';
import MoveInCostsCard from './MoveInCostsCard/MoveInCostsCard';
import PaymentMethodModule from '@renter-hub/components/PaymentMethodModule';
import TransactionLedger from './TransactionLedger';
import ContactUsSection from '@common/components/ContactUsSection';
import { LandlordCard } from './Landlord.card';
import { MonthlyRentCard } from './MonthlyRentCard/MonthlyRentCard';

const LandlordBlocked = ({ rentSubscriptionAutoCanceled }): React.ReactNode => {
  return (
    <>
      <div>
        <LandlordBlockCard />
        <MoveInCostsCard displayHiddenText />
        <MonthlyRentCard displayHiddenText rentSubscriptionAutoCanceled={rentSubscriptionAutoCanceled} />
        <Box
          css={{
            marginTop: 'loose',
            marginBottom: 'loose',
          }}
        >
          <PaymentMethodModule displayHiddenText />
        </Box>
        <LandlordCard displayHiddenText />
      </div>
      <TransactionLedger displayHiddenText />
      <div>
        <ContactUsSection />
      </div>
    </>
  );
};

export default LandlordBlocked;
